module.exports = "/legacy/c8da39438f26a6cd189e75d6c4e0ae72.svg";